import ScaleCard from "../../components/UserDashboard/ScaleCard";
import styles from "./ScalesPage.module.css";

export default function ScalesPage() {
  return (
    <div className={styles.container}>
      {/* ================= HEADER ================= */}
      <header className={styles.header}>
        <h1>Escalas clínicas</h1>
        <p>
          As escalas abaixo são instrumentos de autoaplicação utilizados para
          apoiar o processo terapêutico. Elas não têm finalidade diagnóstica e
          devem ser interpretadas de forma contextual, em conjunto com o
          profissional responsável.
        </p>
      </header>

      {/* ================= ESCALAS ================= */}
      <section className={styles.scalesList}>
        <ScaleCard
          id="aaq-ii"
          title="AAQ-II"
          process="Esquiva experiencial / Inflexibilidade psicológica"
          description="Avalia a tendência a evitar experiências internas difíceis e o impacto disso no funcionamento cotidiano."
          actionLabel="Responder escala"
          actionTo="/scales/aaq-ii"
        />

        <ScaleCard
          id="dass-21"
          title="DASS-21"
          process="Sofrimento emocional (depressão, ansiedade e estresse)"
          description="Avalia níveis de sofrimento emocional recente, auxiliando a contextualização do estado afetivo."
          actionLabel="Responder escala"
          actionTo="/scales/dass-21"
        />

        <ScaleCard
          id="vlq"
          title="VLQ"
          process="Valores e ação comprometida"
          description="Explora a clareza de valores e o grau de ação consistente em diferentes áreas da vida."
          actionLabel="Responder escala"
          actionTo="/scales/vlq"
        />
      </section>
    </div>
  );
}
